/* SearchItem.styles.tsx generated by @compiled/babel-plugin v0.26.0 */
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"],
  _excluded3 = ["as", "style"],
  _excluded4 = ["as", "style"],
  _excluded5 = ["as", "style"],
  _excluded6 = ["as", "style"],
  _excluded7 = ["as", "style"],
  _excluded8 = ["as", "style"],
  _excluded9 = ["as", "style"],
  _excluded10 = ["as", "style"],
  _excluded11 = ["as", "style"];
import { forwardRef } from 'react';
import * as React from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _53 = "._syaztmrq{color:var(--ds-text-selected)}";
const _52 = "._1e0c1o8l{display:inline-block}";
const _51 = "._vwz41k8s{line-height:1.5rem}";
const _50 = "._zg8l4jg8{font-style:normal}";
const _49 = "._1wyb1j6v{font-size:1rem}";
const _48 = "._ect48q0o{font-family:Charlie Text}";
const _47 = "._k48p1nn1{font-weight:400}";
const _46 = "._syaz1blv{color:var(--ds-text)}";
const _45 = "._11q71oj9{background:var(--ds-border-selected)}";
const _44 = "._1bsbyh40{width:2px}";
const _43 = "._94n5idpf{bottom:0}";
const _42 = "._154iidpf{top:0}";
const _41 = "._1ltvidpf{left:0}";
const _40 = "._kqswstnw{position:absolute}";
const _39 = "@media (min-width:64rem){._1yag1pm9{padding:0 var(--ds-space-250) 0 var(--ds-space-300)}._1rdt1ule[aria-selected=true] .selected-marker{display:block}._wrkn1eg3[aria-selected=true]{background:var(--ds-background-neutral-subtle-hovered)}._41ybewfl[aria-selected=true] .suggestion-arrow-icon{visibility:visible}._fkkaewfl:active .suggestion-arrow-icon{visibility:visible}}";
const _38 = "._1vdz1egq:active{border-left:2px solid var(--ds-border-selected)}";
const _37 = "._1lg6glyw .selected-marker{display:none}";
const _36 = "._kqswh2mm{position:relative}";
const _35 = "._1yt41qtk{padding:0 var(--ds-space-050) 0 var(--ds-space-300)}";
const _34 = "._1ul9idpf{min-width:0}";
const _33 = "@media (min-width:64rem){._165t1ylp{height:40px}._1ce74suz:focus-visible:not(:active){border:2px solid var(--ds-border-focused)}._1wapewfl:focus-visible:not(:active) .suggestion-arrow-icon{visibility:visible}}";
const _32 = "._1bsb1osq{width:100%}";
const _31 = "._1bah1yb4{justify-content:space-between}";
const _30 = "._zulp1eps{gap:var(--ds-space-100)}";
const _29 = "._18m915vq{overflow-y:hidden}";
const _28 = "._1reo15vq{overflow-x:hidden}";
const _27 = "._o5721q9c{white-space:nowrap}";
const _26 = "._1bto1l2s{text-overflow:ellipsis}";
const _25 = "@media (min-width:64rem){._w14j15vq{visibility:hidden}._dm251ule{display:block}}";
const _24 = "._1e0cglyw{display:none}";
const _23 = "._4t3i7vkz{height:1pc}";
const _22 = "._1bsb7vkz{width:1pc}";
const _21 = "@media (min-width:64rem){._dm25glyw{display:none}}";
const _20 = "._j6xtfqd3:active{background:var(--ds-background-neutral-subtle-pressed)}";
const _19 = "._11q7glyw{background:none}";
const _18 = "._80omtlke{cursor:pointer}";
const _17 = "._19bvidpf{padding-left:0}";
const _16 = "._n3tdidpf{padding-bottom:0}";
const _15 = "._u5f3idpf{padding-right:0}";
const _14 = "._ca0qidpf{padding-top:0}";
const _13 = "._18u0idpf{margin-left:0}";
const _12 = "._otyridpf{margin-bottom:0}";
const _11 = "._2hwxidpf{margin-right:0}";
const _10 = "._19pkidpf{margin-top:0}";
const _9 = "._19itglyw{border:none}";
const _8 = "._1o9zidpf{flex-shrink:0}";
const _7 = "._4t3ickbl{height:3pc}";
const _6 = "._1bsbt9kd{width:72px}";
const _5 = "._4t3i1tcg{height:24px}";
const _4 = "._1bsb1tcg{width:24px}";
import { media } from '@atlaskit/primitives/responsive';
import { ellipsisCompiled } from '@atlassian/mpac-ui/theme';
const _3 = "._4cvr1h6o{align-items:center}";
const _2 = "._1bah1h6o{justify-content:center}";
const _ = "._1e0c1txw{display:flex}";
export const ParentContainer = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_, _2, _3]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_1e0c1txw _1bah1h6o _4cvr1h6o", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  ParentContainer.displayName = 'ParentContainer';
}
export const Icon24 = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = "img",
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_4, _5]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_1bsb1tcg _4t3i1tcg", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  Icon24.displayName = 'Icon24';
}
export const AppendButton = forwardRef((_ref3, __cmplr) => {
  let {
      as: C = "button",
      style: __cmpls
    } = _ref3,
    __cmplp = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _, _2, _3, _19, _20, _21]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_1bsbt9kd _4t3ickbl _1o9zidpf _19itglyw _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _80omtlke _1e0c1txw _1bah1h6o _4cvr1h6o _11q7glyw _j6xtfqd3 _dm25glyw", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  AppendButton.displayName = 'AppendButton';
}
export const Icon16 = forwardRef((_ref4, __cmplr) => {
  let {
      as: C = "img",
      style: __cmpls
    } = _ref4,
    __cmplp = _objectWithoutProperties(_ref4, _excluded4);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_22, _23]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_1bsb7vkz _4t3i7vkz", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  Icon16.displayName = 'Icon16';
}
export const ArrowIcon = forwardRef((_ref5, __cmplr) => {
  let {
      as: C = "img",
      style: __cmpls
    } = _ref5,
    __cmplp = _objectWithoutProperties(_ref5, _excluded5);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_4, _5, _24, _25]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_1bsb1tcg _4t3i1tcg _1e0cglyw _w14j15vq _dm251ule", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  ArrowIcon.displayName = 'ArrowIcon';
}
export const QueryContainer = forwardRef((_ref6, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref6,
    __cmplp = _objectWithoutProperties(_ref6, _excluded6);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_26, _27, _28, _29, _, _30, _3]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_1bto1l2s _o5721q9c _1reo15vq _18m915vq _1e0c1txw _zulp1eps _4cvr1h6o", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  QueryContainer.displayName = 'QueryContainer';
}
export const Query = forwardRef((_ref7, __cmplr) => {
  let {
      as: C = "button",
      style: __cmpls
    } = _ref7,
    __cmplp = _objectWithoutProperties(_ref7, _excluded7);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_9, _10, _11, _12, _13, _18, _, _31, _32, _7, _3, _19, _14, _15, _16, _17, _33]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_19itglyw _19pkidpf _2hwxidpf _otyridpf _18u0idpf _80omtlke _1e0c1txw _1bah1yb4 _1bsb1osq _4t3ickbl _4cvr1h6o _11q7glyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _165t1ylp _1ce74suz _1wapewfl", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  Query.displayName = 'Query';
}
export const SearchItemContainer = forwardRef((_ref8, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref8,
    __cmplp = _objectWithoutProperties(_ref8, _excluded8);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_, _31, _32, _34, _35, _36, _37, _38, _20, _39]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_1e0c1txw _1bah1yb4 _1bsb1osq _1ul9idpf _1yt41qtk _kqswh2mm _1lg6glyw _1vdz1egq _j6xtfqd3 _1yag1pm9 _1rdt1ule _wrkn1eg3 _41ybewfl _fkkaewfl", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  SearchItemContainer.displayName = 'SearchItemContainer';
}
export const SelectedMarker = forwardRef((_ref9, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref9,
    __cmplp = _objectWithoutProperties(_ref9, _excluded9);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_40, _41, _42, _43, _44, _45]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_kqswstnw _1ltvidpf _154iidpf _94n5idpf _1bsbyh40 _11q71oj9", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  SelectedMarker.displayName = 'SelectedMarker';
}
export const Text = forwardRef((_ref10, __cmplr) => {
  let {
      as: C = "span",
      style: __cmpls
    } = _ref10,
    __cmplp = _objectWithoutProperties(_ref10, _excluded10);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_26, _27, _28, _29, _46, _47, _48, _49, _50, _51, _52]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_1bto1l2s _o5721q9c _1reo15vq _18m915vq _syaz1blv _k48p1nn1 _ect48q0o _1wyb1j6v _zg8l4jg8 _vwz41k8s _1e0c1o8l", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  Text.displayName = 'Text';
}
export const TextHighlighted = forwardRef((_ref11, __cmplr) => {
  let {
      as: C = "span",
      style: __cmpls
    } = _ref11,
    __cmplp = _objectWithoutProperties(_ref11, _excluded11);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_52, _53, _47]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_1e0c1o8l _syaztmrq _k48p1nn1", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  TextHighlighted.displayName = 'TextHighlighted';
}